import { render, staticRenderFns } from "./modal-give-access.vue?vue&type=template&id=9ff55aa4&"
import script from "./modal-give-access.vue?vue&type=script&lang=js&"
export * from "./modal-give-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports